(function () {
    'use strict';

    angular
        .module('salesflare.components.associatedfieldsDisplay', [])
        .component('sfAssociatedfieldsDisplay', {
            controller,
            controllerAs: 'vm',
            templateUrl: 'app-ajs/components/associatedfields/associatedfieldsdisplay.html',
            bindings: {
                entity: '<',
                itemClass: '<',
                hideHeader: '<',
                showFieldsIcon: '<'
            }
        });

    function controller($mdMedia, $state, $q, customfields, flagsService) {

        const vm = this;

        const knownTypes = new Set(['opportunity', 'account', 'contact']);

        vm.isEnabled = flagsService.get('associatedFields') === true;

        vm.typeIcons = {
            opportunity: 'sf-icon-opportunities',
            account: 'sf-icon-accounts',
            contact: 'sf-icon-contact'
        };

        vm.$onChanges = function (changes) {

            if (vm.isEnabled && changes.entity && changes.entity.currentValue) {
                build();
            }
        };

        vm.changeExtended = function (field) {

            field.extended = !field.extended;
        };

        vm.goToEntity = (type, entity) => {

            let state;
            const stateParams = {
                id: entity.id
            };

            switch (type) {
                case 'opportunity':
                case 'opportunities':
                    state = 'opportunity';
                    break;
                case 'account':
                case 'accounts':
                    stateParams.name = entity.name;
                    if ($mdMedia('gt-sm')) {
                        state = 'accounts.account.feed';
                    }
                    else {
                        state = 'accounts.account.info';
                    }

                    break;
                case 'contact':
                case 'contacts':
                    state = 'contact';
                    break;
            }

            return $state.go(state, stateParams);
        };

        function build() {

            // Capture the entity reference so the async callback can detect staleness.
            const capturedEntity = vm.entity;
            const association = capturedEntity.association || {};
            const groups = Object.keys(association);

            if (groups.length === 0) {
                vm.associatedFields = [];
                vm.hasAssociatedFields = false;
                return;
            }

            // Clear immediately so the previous entity's fields are not shown while
            // the new requests are in-flight. Leave hasAssociatedFields undefined so
            // the template does not flash the "no associated fields" empty state
            // before customfields.getFields resolves.
            vm.associatedFields = [];
            vm.hasAssociatedFields = undefined;

            // Field labels are not part of the association payload, so look them up
            // per group through the custom field definitions and map api_field -> name.
            // Only include groups that customfields.getFields supports; unknown keys
            // would return undefined and calling .then on undefined throws.
            const requests = groups
                .filter(function (group) {

                    return knownTypes.has(group);
                })
                .map(function (group) {

                    return customfields.getFields(group, true).then(function (response) {

                        return {
                            group,
                            fields: response.data
                        };
                    });
                });

            return $q.all(requests).then(function (results) {

                // A slower response from a previous entity must not overwrite the
                // fields that belong to the record currently on screen.
                if (capturedEntity !== vm.entity) {
                    return;
                }

                const associatedFields = [];

                results.forEach(function (result) {

                    const nameByApiField = {};
                    result.fields.forEach(function (field) {

                        nameByApiField[field.api_field] = field.name;
                    });

                    const groupValues = association[result.group] || {};
                    Object.keys(groupValues).forEach(function (apiField) {

                        const entities = groupValues[apiField];

                        if (angular.isArray(entities) && entities.length > 0) {
                            const name = nameByApiField[apiField] || apiField;

                            associatedFields.push({
                                type: result.group,
                                api_field: apiField,
                                name,
                                entities
                            });
                        }
                    });
                });

                vm.associatedFields = associatedFields;
                vm.hasAssociatedFields = associatedFields.length > 0;

                if (vm.showFieldsIcon && vm.hasAssociatedFields) {
                    vm.associatedFields[0].first = true;
                }
            });
        }
    }
}());
